module.exports = __webpack_public_path__ + "static/ourwork-custom-exhibit-designs-92659dc2883973193367ad9d7ff1fe82.jpg";